/*
 * PDP gallery: show only the selected variant's images plus the shared ones.
 * Media items carry data-variant-media="pink|blue" (snippets/variant-media-tags.liquid);
 * items without it are shared by every variant.
 */
document.addEventListener('DOMContentLoaded', function () {
  var $ = window.jQuery;
  if (!$ || !$.fn.slick) return;

  function tagsOf(slide) {
    var $slide = $(slide);
    var tags = $slide.attr('data-variant-media') || $slide.find('[data-variant-media]').first().attr('data-variant-media');
    return tags ? tags.split('|') : [];
  }

  function matches(slide, values) {
    var tags = tagsOf(slide);
    if (!tags.length) return true;
    for (var i = 0; i < tags.length; i++) {
      if (values.indexOf(tags[i]) !== -1) return true;
    }
    return false;
  }

  function applyFilter($gallery, values) {
    var $main = $gallery.find('.js-product-media-group.slick-initialized');
    var $thumbs = $gallery.find('.js-product-thumbnails.slick-initialized');
    if (!$main.length) return false;

    var key = values.join('|');
    if ($gallery.data('variantMediaKey') === key) return true;
    $gallery.data('variantMediaKey', key);

    [$main, $thumbs].forEach(function ($slider) {
      if (!$slider.length) return;
      $slider.slick('slickUnfilter');

      // Nothing tagged for this variant: show everything rather than only the shared images
      var hasOwn = $slider.find('[data-variant-media]').filter(function () {
        return matches(this, values);
      }).length;
      if (hasOwn) {
        $slider.slick('slickFilter', function (index, slide) {
          return matches(slide, values);
        });
      }

      // Slick keeps the pre-filter data-slick-index; the theme and thumbnail clicks navigate by it
      $slider.find('.slick-slide:not(.slick-cloned)').each(function (position) {
        $(this).attr('data-slick-index', position).removeData('slick-index');
      });
      $slider.slick('slickGoTo', 0, true);
    });
    return true;
  }

  function valuesOf(options) {
    return options.map(function (value) {
      return String(value).toLowerCase().trim();
    });
  }

  $('[data-variant-media-filter]').each(function () {
    var $gallery = $(this);
    if (!$gallery.find('[data-variant-media]').length) return;

    var initial = String($gallery.data('selected-values') || '').split('|');
    var tries = 0;
    var timer = setInterval(function () {
      if (applyFilter($gallery, initial) || ++tries > 50) clearInterval(timer);
    }, 200);

    // The theme triggers variantChange on the product section before it moves the gallery to the variant image
    $gallery.closest('.shopify-section').on('variantChange', function (evt) {
      if (evt.variant && evt.variant.options) applyFilter($gallery, valuesOf(evt.variant.options));
    });
  });
});
